

import React, { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import { Button } from '../../components/ui/button';
import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import FileUploadInput from 'components/reusable/FileUploadInput';
import ErrorMessage from 'components/ErrorMessage';
import FormValidation from 'utils/formValidation';
import PhoneInput from 'react-phone-input-2';
import { apiGet, apiPost, apiPut } from 'utils/apiFetch';
import apiPath from 'utils/apiPath';
import useToastContext from 'hooks/useToastContext';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import helpers from 'utils/helpers';
import { IoCaretBackCircleOutline } from 'react-icons/io5';
import { isEmpty } from 'lodash';
import { IoIosAdd } from 'react-icons/io';
import { FaEdit } from 'react-icons/fa';
export default function AddDriver() {
  const formValidation = FormValidation()
  const inputRef = useRef(null);
  const [countryCode] = useState("us");
  const location = useLocation()
  const isView = location.pathname == '/driver-manager/view'
  const isEdit = location.pathname == '/driver-manager/edit'
  const notification = useToastContext();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [serviceOffered, setServicesOffered] = useState([])

  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors },

  } = useForm({ mode: "onChange", shouldFocusError: true, defaultValues: {} });



  const readFileAsArrayBuffer = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsArrayBuffer(file);
    });
  };


  const getPreSignUrl = async (file) => {
    try {
      const payloadPre = {
        contentType: file?.type,
      };
      const path = apiPath.generatePeoviderPreSignUrl;
      const result = await apiPost(path, payloadPre);
      if (result?.data?.success) {
        const buffer = await readFileAsArrayBuffer(file);
        const resp = await axios.put(result?.data?.results?.url, buffer, {
          headers: {
            "Content-Type": file.type || "application/octet-stream",
          },
        });

        if (resp?.status === 200) {
          return result?.data?.results;
        }
      }
    } catch (error) {
      console.error("--------error------------", error);
    }
  }


  const [isPending, setPending] = useState(false)

  const getFileValue = (val) => {
    if (typeof val === "string") return val;
    if (val?.length > 0) return val[0];
    return null;
  }


  const handleAddDriver = async (e) => {
    e.mobile = e?.mobile?.substring(inputRef?.current?.state.selectedCountry?.countryCode?.length, e?.mobile?.toString()?.length);
    e.countryCode = inputRef?.current?.state.selectedCountry?.countryCode;

    try {


      const files = {
        // governmentIDDocFront: getFileValue(e?.governmentIDDocFront),
        // governmentIDDocBack: getFileValue(e?.governmentIDDocBack),
        // insurancePolicyDoc: getFileValue(e?.insurancePolicyDoc),
        licenseDocBack: getFileValue(e?.licenseDocBack),
        licenseDocFront: getFileValue(e?.licenseDocFront),
      };

      const uploadedUrls = {
        // governmentIDDocFront: '',
        // governmentIDDocBack: '',
        // insurancePolicyDoc: '',
        licenseDocBack: '',
        licenseDocFront: '',
      };
      setPending(true)

      for (const key in files) {

        const file = files[key];

        if (typeof file !== 'string') {

          const presignedUrl = await getPreSignUrl(file);
          if (!presignedUrl?.key) {
            throw new Error(`Upload failed for ${key}`);
          }
          switch (key) {
            // case 'governmentIDDocFront':
            //   uploadedUrls.truckDOTNumberDocFront = presignedUrl.key;
            //   break;
            // case 'governmentIDDocBack':
            //   uploadedUrls.truckDOTNumberDocBack = presignedUrl.key;
            //   break;
            // case 'insurancePolicyDoc':
            //   uploadedUrls.insurancePolicyDoc = presignedUrl.key;
            //   break;
            case 'licenseDocBack':
              uploadedUrls.licenseDocBack = presignedUrl.key;
              break;
            case 'licenseDocFront':
              uploadedUrls.licenseDocFront = presignedUrl.key;
              break;

          }
        }
      }



      const { governmentIDDocBack, governmentIDDocFront, insurancePolicyDoc, licenseDocBack, licenseDocFront, ...rest } = e
      let payload = {}
      if (e?.profilePic?.length > 0) {
        const profilePresign = await getPreSignUrl(e?.profilePic?.[0]);
        payload = {
          ...rest,
          profilePic: profilePresign?.key,
          ...uploadedUrls,
        };
      } else {
        payload = {
          ...rest,
          ...uploadedUrls,
        };

      }

      payload.serviceOffered = serviceOffered?.map((res) => res?._id)
      const resp = isEdit ? await apiPut(apiPath.editDriver + '/' + location?.state?._id, payload) : await apiPost(apiPath.addDriver, payload)
      if (resp?.data?.success) {
        notification.success(resp?.data?.message)
        navigate('/driver-manager')
        setPending(false)
        return
      }
      notification.error(resp?.data?.message)
      setPending(false)

    } catch (err) {
      console.log('Error in add driver:', err);
      setPending(false)
    }
  }



  const preventSpace = (e) => {
    if (e?.which === 32) {
      e.preventDefault();
    }
  };


  const getServices = async (e) => {
    try {
      const resp = await apiGet(apiPath.getUserProfileData)
      if (resp?.data?.success) {
        setServicesOffered(resp?.data?.results?.specialtyServices)
        return
      }
      setServicesOffered([])

    } catch (err) {
      console.log('err', err)

    }
  }


  useEffect(() => {
    getServices()
  }, [])



  useEffect(() => {
    if (helpers.andOperator(helpers.orOperator(isEdit, isView), !isEmpty(location?.state))) {
      const { licenseDocBack, licenseDocFront, insurancePolicyDoc, governmentIDDocFront, profilePic, governmentIDDocBack, truckDOTNumberDocFront, truckDOTNumberDocBack, ...rest } = location?.state
      reset({ licenseDocBack, licenseDocFront, insurancePolicyDoc, governmentIDDocFront: truckDOTNumberDocFront, profilePic, governmentIDDocBack: truckDOTNumberDocBack, fullName: rest?.fullName, role: rest?.role, vehicleNumber: rest?.vehicleNumber, email: rest?.email, additionalNotes: rest?.additionalNotes, truckDOTNumber: rest?.truckDOTNumber, mobile: helpers.ternaryCondition(rest?.countryCode, rest?.countryCode + rest?.mobile, "na"), caNumber: rest?.caNumber, serviceOffered: rest?.serviceOffered?.map((res) => res?._id) })
    } else if (helpers.andOperator(helpers.orOperator(isEdit, isView), isEmpty(location?.state))) {
      navigate('/driver-manager')
    }


  }, [location])



  return (

    <div className='h-[846px] bg-gradient-to-br from-gray-100 to-gray-200 p-6'>
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="max-w-5xl mx-auto  bg-white rounded-2xl shadow-xl mt-8 space-y-6 overflow-hidden"
      >
        <div className='max-h-[770px] overflow-y-auto p-6 md:p-10'>
          <form onSubmit={handleSubmit(handleAddDriver)}>
            <div className='flex justify-between'>
              <h2 className="text-2xl font-bold mb-6 text-gray-800">{helpers.ternaryCondition(isEdit, 'Edit', helpers.ternaryCondition(isView, 'View', 'Add'))} {t("DRIVER")}</h2>

            </div>
            <div className='mt-6 mb-9 flex justify-center'>
              <div>
                <Controller
                  name={'profilePic'}
                  control={control}
                  rules={{
                    required: t("PLEASE_SELECT_PROFILE"),
                    validate: {
                      acceptedFormats: (file) => {
                        if (typeof file === "string") return undefined;
                        return (
                          file &&
                          ["image/jpg", "image/png", "image/jpeg"].includes(file[0]?.type)
                        ) || "Only JPG, PNG files are allowed.";
                      },

                      fileSize: (file) => {
                        if (typeof file === "string") return undefined;

                        const maxSize = 5 * 1024 * 1024;
                        const isValidSize = file && file[0].size <= maxSize;
                        return isValidSize ? undefined : "File must be less than 5MB.";
                      }
                    }

                  }}

                  render={({ field: { onChange, value }, fieldState: { error } }) => (
                    <>
                      {value ? (
                        <>
                          <div className='flex justify-center'>
                            <div>
                              <figure className="w-[100px] relative overflow-hidden rounded-lg block mb-2">

                                <img className="h-20 w-40" src={helpers.getFileORUrl(value)} alt="uploadImg" onError={(e) => { e.target.onerror = null; e.target.src = "/images/no-images.png"; }} />
                                {helpers.andOperator(!isView, <button className="absolute top-2 right-2" onClick={() => onChange(null)}>
                                  <img src="/images/croseImg.svg" />
                                </button>)}

                              </figure>
                              <h5 className="text-sm text-[#A5A5A5] block text-center w-[100px]">
                                {t("PROFILE_PICTURE")}
                              </h5>

                            </div>
                          </div>
                          <ErrorMessage message={errors?.profilePic?.message} />
                        </>
                      ) : (
                        <>
                          <div className='flex justify-center'>
                            <div>
                              <div className="w-[100px] h-[60px] relative bg-[#F3F3F3] border border-[#DFDFDF] rounded-lg p-4 flex items-center justify-center mb-2">
                                <span>
                                  <img
                                    src="/images/uploadBack.svg"
                                    alt="uploadprofile"
                                  />
                                </span>
                                <input
                                  type="file"
                                  accept={".jpg,.jpeg,.png"}
                                  onChange={(e) => onChange(e?.target?.files)}
                                  className="absolute top-0 bottom-0 left-0 right-0 opacity-0"

                                />
                              </div>

                              <h5 className="text-sm text-[#A5A5A5] block text-center w-[100px]">
                                {t("PROFILE_PICTURE")}
                              </h5>
                            </div>

                          </div>
                          <ErrorMessage message={errors?.profilePic?.message} />
                        </>
                      )}
                    </>
                  )}
                />
              </div>
            </div>
            <div className="grid md:grid-cols-2 gap-6">
              <div className="relative z-0 w-full group mb-3 sm:mb-0">
                <input
                  type="text"
                  id="fullName"
                  className=" block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-black dark:border-[#DFDFDF]  focus:outline-none focus:ring-0  peer"
                  placeholder=" "
                  name="fullName"
                  disabled={isView}
                  {...register("fullName",
                    formValidation.fullName)}
                />

                <label
                  htmlFor="fullName"
                  className=" dark:text-gray-500 peer-focus:font-normal absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white dark:bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg  peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                  >
                  {t("FULL_NAME")}
                  <span className="text-red-500">*</span>
                </label>
                <ErrorMessage message={errors?.fullName?.message} />
              </div>

              <div className="relative z-0 w-full group mb-3 sm:mb-0 z-50">
                <Controller
                  control={control}
                  name="mobile"
                  disabled={isView}
                  rules={{
                    required: t("PLEASE_ENTER_MOBILE_NO"),
                    validate: (value) => {
                      const inputValue = value?.toString()?.slice(inputRef?.current?.state?.selectedCountry?.countryCode?.length, value?.length);
                      if (inputValue?.length < 7) {
                        return t("MOBILE_NO_GREATER");
                      } else if (inputValue?.length > 12) {
                        return t("MOBILE_NO_EX");;
                      }
                    },
                  }}
                  render={({ field: { ref, ...field } }) => (
                    <PhoneInput
                      {...field}
                      inputExtraProps={{
                        ref,
                        required: true,
                        autoFocus: true,
                      }}
                      ref={inputRef}
                      inputStyle={{
                        width: "100%",
                        height: "54px",
                      }}

                      style={{ borderRadius: "20px" }}
                      country={countryCode}
                      enableSearch={false}
                      onlyCountries={["us"]}
                      countryCodeEditable={false}
                    />
                  )}
                />
                <ErrorMessage message={errors?.mobile?.message} />
              </div>
            </div>

            <div className="grid md:grid-cols-2 md:gap-6">
              <div className="mt-6">
                <select
                  disabled={isView}
                  {...register("role",

                    { required: 'Please select role.' })}
                  className="mt-1 block w-full px-4 py-4 text-sm bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                >
                  <option value=''>Select Role</option>
                  <option value='driver'>Driver</option>
                  {/* <option value='dispatcher'>Dispatcher</option>
                <option value='assistant'>Assistant</option> */}

                </select>
                <ErrorMessage message={errors?.role?.message} />
              </div>
              <div className="mt-6">
                <div className="relative z-0 w-full group mb-3 sm:mb-0">
                  <input
                    type="text"
                    id="email"
                    className=" block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-black dark:border-[#DFDFDF]  focus:outline-none focus:ring-0  peer"
                    placeholder=" "
                    name="email"
                    disabled={isView}
                    onKeyDown={(e) => preventSpace(e)}
                    {...register("email",
                      formValidation.email)}
                  />

                  <label
                    htmlFor="email"
                    className=" dark:text-gray-500 peer-focus:font-normal absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white dark:bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg  peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                    >
                    {t("O_EMAIL_ID")}
                    <span className="text-red-500">*</span>
                  </label>
                  <ErrorMessage message={errors?.email?.message} />
                </div>
              </div>
            </div>

            <div className="mt-6 grid md:grid-cols-2 gap-6">

              {helpers.andOperator(isView, <>
                <div className="relative z-0 w-full group mb-3 sm:mb-0">
                  <input
                    type={"text"}
                    name="caNumber"
                    id="caNumber"
                    maxLength={40}
                    disabled={isView}
                    className=" block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-black dark:border-[#DFDFDF]  focus:outline-none focus:ring-0  peer"
                    placeholder=" "
                    autoComplete="caNumber"
                    {...register("caNumber")}
                  />
                  <label
                    htmlFor="caNumber"
                    className=" dark:text-gray-500 peer-focus:font-normal absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white dark:bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg  peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                    >
                    {t("CA_NUMBER")}
                    {/* <span className="text-red-500">*</span> */}
                  </label>

                  <ErrorMessage message={errors?.caNumber?.message} />
                </div>

                <div className="relative z-0 w-full group mb-3 sm:mb-0">
                  <input
                    type={"text"}
                    name="truckDOTNumber"
                    id="truckDOTNumber"
                    maxLength={40}
                    disabled={isView}
                    className=" block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-black dark:border-[#DFDFDF]  focus:outline-none focus:ring-0  peer"
                    placeholder=" "
                    autoComplete="truckDOTNumber"
                    {...register("truckDOTNumber")}
                  />
                  <label
                    htmlFor="truckDOTNumber"
                    className=" dark:text-gray-500 peer-focus:font-normal absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white dark:bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg  peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                    >
                    {t("TRUCK_DOT_NUMBER")}
                    <span className="text-red-500">*</span>
                  </label>

                  <ErrorMessage message={errors?.truckDOTNumber?.message} />
                </div>

                <div className="relative z-0 w-full group mb-3 sm:mb-0">
                  <input
                    type="text"
                    id="vehicleNumber"
                    className=" block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-black dark:border-[#DFDFDF]  focus:outline-none focus:ring-0  peer"
                    placeholder=" "
                    name="vehicleNumber"
                    disabled={isView}
                    maxLength={20}
                    onKeyDown={(e) => preventSpace(e)}
                    {...register("vehicleNumber" )}
                  />

                  <label
                    htmlFor="vehicleNumber"
                    className=" dark:text-gray-500 peer-focus:font-normal absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white dark:bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg  peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                    >
                    {t("VEHICLE_NUMBER")}
                    <span className="text-red-500">*</span>
                  </label>
                  <ErrorMessage message={errors?.vehicleNumber?.message} />
                </div>

              </>)}

              {/* <div> */}
              <div className="relative z-0 w-full group mb-3 sm:mb-0">
                <textarea
                  type="text"
                  id="additionalNotes"
                  className=" block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-black dark:border-[#DFDFDF]  focus:outline-none focus:ring-0  peer"
                  placeholder=" "
                  rows="4"
                  name="additionalNotes"
                  disabled={isView}
                  {...register("additionalNotes", formValidation.additionalNotes)}
                />

                <label
                  htmlFor="additionalNotes"
                  className=" dark:text-gray-500 peer-focus:font-normal absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white dark:bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg  peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                  >
                  {t("Additional Notes")}
                  {/* <span className="text-red-500">*</span> */}
                </label>
                <ErrorMessage message={errors?.additionalNotes?.message} />
              </div>


              {/* </div> */}


              <div className='hidden'>
                <label className="block text-sm font-medium text-gray-700 mb-2">Services<span className='text-red-500'>*</span></label>
                <div className="space-y-2">
                  <Controller
                    control={control}
                    name="serviceOffered"
                    // rules={{
                    //   validate: value => value?.length > 0 || 'Please select at least one service.'
                    // }}
                    render={({ field }) => {
                      const { value = [], onChange } = field

                      const handleCheckboxChange = (checked, id) => {
                        if (checked) {
                          onChange([...value, id])
                        } else {
                          onChange(value?.filter(val => val !== id))
                        }
                      }

                      return serviceOffered?.map((res) => {
                        const isChecked = value?.includes(res._id)
                        return (
                          <div className="flex items-center gap-2" key={res?._id}>
                            <input
                              type="checkbox"
                              id={`serviceOffered${res?._id}`}
                              className="h-4 w-4 text-blue-600 cursor-pointer"
                              checked={isChecked}
                              disabled={isView}
                              onChange={(e) => handleCheckboxChange(e?.target?.checked, res._id)}
                            />
                            <label htmlFor={`serviceOffered${res?._id}`} className="text-gray-700 cursor-pointer">
                              {helpers.capitalizeFirstWord(res?.name)}
                            </label>
                          </div>
                        )
                      })
                    }}
                  />
                  {errors.serviceOffered && (
                    <p className="text-sm text-red-500 mt-1">{errors.serviceOffered.message}</p>
                  )}
                </div>
              </div>
            </div>


            <div className="mt-6">
              <div className="px-3">
                <div className="sm:grid grid-cols-2 gap-6">
                  {/* <div>
                    <h4 className="mb-1 font-bold text-[#151513]">
                      Truck DOT Number Certifications
                    </h4>
                    <p className="text-sm">
                      Truck DOT Number certifications for your services
                    </p>
                    <div className="flex flex-wrap md:grid grid-cols-3 gap-3 pt-2">
                      <div className='mx-5'>
                        <FileUploadInput
                          label="Upload Front"
                          name="governmentIDDocFront"
                          control={control}
                          rules={{
                            required: "Please select truck dot number certificate(front).",
                            validate: {
                              acceptedFormats: (file) => {
                                if (typeof file === "string") return undefined;
                                return (
                                  file &&
                                  ["image/jpg", "image/png", "image/jpeg"].includes(file[0]?.type)
                                ) || "Only JPG, PNG files are allowed.";
                              },

                              fileSize: (file) => {
                                if (typeof file === "string") return undefined;

                                const maxSize = 5 * 1024 * 1024;
                                const isValidSize = file && file[0].size <= maxSize;
                                return isValidSize ? undefined : "File must be less than 5MB.";
                              }
                            }
                          }}
                          accept=".jpg,.jpeg,.png"
                          isView={isView}
                        />

                      </div>

                      <div className='mx-5'>
                        <FileUploadInput
                          label="Upload Back"
                          name="governmentIDDocBack"
                          control={control}
                          rules={{
                            required: "Please select truck dot number certificate(back).",
                            validate: {
                              acceptedFormats: (file) => {
                                if (typeof file === "string") return undefined;
                                return (
                                  file &&
                                  ["image/jpg", "image/png", "image/jpeg"].includes(file[0]?.type)
                                ) || "Only JPG, PNG files are allowed.";
                              },

                              fileSize: (file) => {
                                if (typeof file === "string") return undefined;

                                const maxSize = 5 * 1024 * 1024;
                                const isValidSize = file && file[0].size <= maxSize;
                                return isValidSize ? undefined : "File must be less than 5MB.";
                              }
                            }

                          }}
                          isView={isView}
                          accept=".jpg,.jpeg,.png"
                        />


                      </div>
                    </div>
                    <ErrorMessage message={errors?.governmentIDDocFront?.message} />
                    <ErrorMessage message={errors?.governmentIDDocBack?.message} />
                  </div> */}

                  {/* <div>
                    <h4 className="mb-1 font-bold text-[#151513]">
                      {t("INSURANCE_POLICY")}
                    </h4>
                    <p className="text-sm">
                      {t("VALID_INSURANCE")}
                    </p>

                    <div className="flex flex-wrap md:grid grid-cols-3 gap-3 pt-2">
                      <div className='mx-5'>
                        <FileUploadInput
                          label="Upload PDF"
                          name="insurancePolicyDoc"
                          control={control}
                          rules={{
                            required: t("SELECT_INSURANCE_POLICY"),

                            validate: {
                              acceptedFormats: (file) => {
                                if (typeof file === "string") return undefined;
                                return (
                                  file &&
                                  ["application/pdf"].includes(file[0]?.type)
                                ) || "Only PDF file is allowed.";
                              },

                              fileSize: (file) => {
                                if (typeof file === "string") return undefined;

                                const maxSize = 10 * 1024 * 1024;
                                const isValidSize = file && file[0].size <= maxSize;
                                return isValidSize ? undefined : "File must be less than 10MB.";
                              }
                            }
                          }}
                          isView={isView}
                          accept=".pdf"
                          fileType='pdf'
                        />


                      </div>
                    </div>
                    <ErrorMessage message={errors?.insurancePolicyDoc?.message} />
                  </div> */}

                  <div>
                    <h4 className="mb-1 font-bold text-[#151513]">
                      {t("DRIVER_LICENSE")}
                    </h4>
                    <p className="text-sm">
                      {t("VALID_DRIVER_LICENSE")}
                    </p>
                    <div className="flex flex-wrap md:grid grid-cols-3 gap-3 pt-2">
                      <div className='mx-5'>
                        <FileUploadInput
                          label="Upload Front"
                          name="licenseDocFront"
                          control={control}


                          rules={{
                            required: t("PLEASE_SELECT_DRIVER_LICENSE_FRONT"),

                            validate: {
                              acceptedFormats: (file) => {
                                if (typeof file === "string") return undefined;
                                return (
                                  file &&
                                  ["image/jpg", "image/png", "image/jpeg"].includes(file[0]?.type)
                                ) || "Only JPG, PNG files are allowed.";
                              },

                              fileSize: (file) => {
                                if (typeof file === "string") return undefined;

                                const maxSize = 5 * 1024 * 1024;
                                const isValidSize = file && file[0].size <= maxSize;
                                return isValidSize ? undefined : "File must be less than 5MB.";
                              }
                            }

                          }}
                          accept=".jpg,.jpeg,.png"
                          isView={isView}
                        />

                      </div>

                      <div className='mx-5'>
                        <FileUploadInput
                          label="Upload Back"
                          name="licenseDocBack"
                          control={control}
                          rules={{
                            required: t("PLEASE_SELECT_DRIVER_LICENSE_BACK"),
                            validate: {
                              acceptedFormats: (file) => {
                                if (typeof file === "string") return undefined;
                                return (
                                  file &&
                                  ["image/jpg", "image/png", "image/jpeg"].includes(file[0]?.type)
                                ) || "Only JPG, PNG files are allowed.";
                              },

                              fileSize: (file) => {
                                if (typeof file === "string") return undefined;

                                const maxSize = 5 * 1024 * 1024;
                                const isValidSize = file && file[0].size <= maxSize;
                                return isValidSize ? undefined : "File must be less than 5MB.";
                              }
                            }

                          }}
                          accept=".jpg,.jpeg,.png"
                          isView={isView}
                        />


                      </div>
                    </div>
                    <ErrorMessage message={errors?.licenseDocFront?.message} />
                    <ErrorMessage message={errors?.licenseDocBack?.message} />
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-8 flex justify-end">

              <Button className="  flex gap-2 px-5 ml-3 mb-3 py-2 rounded-lg items-center border border-transparent sm:w-auto bg-[#E1E1E1] text-black h-[40px]"
                title={t("O_BACK")}
                onClick={() => location?.state?.from === 'calendar' ? navigate("/driver-manager/availability-calendar") : location?.state?.from === 'vehicle' ? navigate("/vehicle-manager") : navigate("/driver-manager")}>
                <IoCaretBackCircleOutline size={18} />
                {t("O_BACK")}</Button>
              {helpers.andOperator(!isView, <Button className="bg-gradientTo text-sm flex gap-2 px-5 ml-3 mb-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue sm:w-auto "> {helpers.ternaryCondition(isPending, 'Submitting...', helpers.ternaryCondition(isEdit, <><FaEdit size={16} className='mb-[3px]' />Edit </>, <><IoIosAdd size={20} className='mb-[2px]' />Add </>))}</Button>)}
            </div>
          </form>
        </div>
      </motion.div >



      {helpers.andOperator(isPending, <div id='loader' className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[999] ">
        <div className="w-8 h-8 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        <span className='visually-hidden ml-2 '>Loading...</span>
      </div>)}
    </div>
  );
}
